export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70b77bd7710ba6002a20151f00607268dfe6e7d399&name=pushAdClickData!'